$(document).ready(function () {
	$('.catalog-form-trigger').change(function () {
		$("#catalog-form-filter").submit();
	});
});